/*
 * 文件EN: currentRepayment.js,
 * 文件CN: 商户还款-账单查询,

 */

import request from '@/plugins/http'

/**
 * @desc 商户还款--还款列表查询复制  第一个table 主页列表
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/period/list', params)
}



export const getDetails = params => {
  return request.get('/period/list/detail', params)
}
